<div class="delivery-details container"
     [appLoadingAnimation]="isUserDataLoading || isCartEmpty || loadingCartDataInProgress">
  <app-spare-part-order-details-section
      *ngIf="cartDataLoaded && cartItemsDataLoaded && !loadingCartDataInProgress"
      [ngClass]="{'hidden': isOnContactDetailsSection}"
      [cartId]="cartId"
      [cartAttributes]="cartAttributes"
      [cartItemsWithDetails]="cartItemsWithDetails"
      [cartRules]="cartRules"
      [systemDetails]="systemDetails"
      [loggedUserRoles]="userData.companyRoles"
      [userLoggedData]="userData"
      [isSaturdayShipment]="isSaturdayShipment"
      [isPriceDisputingActive]="isPriceDisputingActive"
      (formSubmitted)="proceedToContactDetails($event)"
      (isSaturdayShipmentEmitter)="updateIsSaturdayShipment($event)"
      (addressChangedEmitter)="addressChanged = $event">
  </app-spare-part-order-details-section>
  <app-spare-part-contact-details-section
      *ngIf="cartDataLoaded && cartItemsDataLoaded && !loadingCartDataInProgress"
      [ngClass]="{'hidden': !isOnContactDetailsSection}"
      [cartId]="cartId"
      [cartAttributes]="cartAttributes"
      [cartItemsWithDetails]="cartItemsWithDetails"
      [cartRules]="cartRules"
      [creatingOrderInProgress]="creatingOrderInProgress"
      [isOnContactDetailsSection]="isOnContactDetailsSection"
      [addressChanged]="addressChanged"
      [isPriceDisputingActive]="isPriceDisputingActive"
      (backToOrderDetails)="proceedToOrderDetails()"
      (formSubmitted)="createOrder($event)"
      (isSaturdayShipmentEmitter)="isSaturdayShipment = $event">
  </app-spare-part-contact-details-section>
</div>
